import React, { useState, useEffect } from "react";
import VisDiv from "./frontend_components/VisDiv";
import { keyId } from "../lib/utils";
import { FaBold, FaItalic, FaUnderline } from "react-icons/fa";
import { GoListUnordered, GoListOrdered } from "react-icons/go";

import { Editor, EditorState, RichUtils, convertFromRaw, convertToRaw } from "draft-js";
import "draft-js/dist/Draft.css";

const RichTextEditor = ({text="", onBlur=()=>{}, noFocus, existingDoc, readOnly, fullWidth, customWidth ="100rem", saveLoad, editorDoc = ()=> {}, updateInitialData}) => {
  const doc = {
    blocks:[
      {
        //data:{},
        //depth: 0,
        //entityRanges: [],
        //inlineStyleRanges:[],
        key: keyId(),
        text,
        type:"unstyled"
      }
    ],
    entityMap:{}
  }

  const initialData = () => {
    if (existingDoc?.blocks?.length > 0){ 
      return EditorState?.createWithContent(convertFromRaw(existingDoc))}
    
    //if (!existingDoc, text) return EditorState?.createWithContent(convertFromRaw(doc))
    return EditorState.createEmpty()
  }
    useEffect(()=>{
      if(updateInitialData){
        setEditorState(initialData())
      }
    
      //console.log("initial Data Rich Text Editor", existingDoc)
    },[existingDoc])
    // took out existingDoc as dependancy as it was making offer. if I want to use this dependancy will need an if statement for when I need to use it

    const [editorState, setEditorState] = useState(initialData());
    const [savedContent, setSavedContent] = useState({})
    const testing = false
    const testFunction = () => {
        console.log("editorState", convertToRaw(editorState?.getCurrentContent()), editorState?.getCurrentContent())
    }
    const saveContent = () => {
        console.log("editorState", convertToRaw(editorState?.getCurrentContent()))
        setSavedContent(convertToRaw(editorState?.getCurrentContent()))
    }
    const loadContent = () => {
        //console.log("editorState", convertToRaw(editorState.getCurrentContent()))
        setEditorState(EditorState.createWithContent(convertFromRaw(savedContent)))
    }
  
    const editor = React.useRef(undefined);
  
    function focusEditor() {
      editor?.current.focus();
    }
  
    useEffect(() => {
      if(!noFocus){
        focusEditor();
      }
    
    }, []);
  
    const StyleButton = (props) => {
      let onClickButton = (e) => {
        e.preventDefault();
        props.onToggle(props.style);
      };
      return <div style={{border:"none", padding:"5px", cursor:"pointer"}} onMouseDown={onClickButton}>{props.icon}{props.label}</div>;
    };
  
    const BLOCK_TYPES = [
      //{ label: "H1", style: "header-one", icon: "h1" },
     // { label: "H2", style: "header-two" },
     // { label: "H3", style: "header-three" },
     // { label: "H4", style: "header-four" },
      //{ label: "H5", style: "header-five" },
      //{ label: "H6", style: "header-six" },
      { label: "UL", style: "unordered-list-item", icon: <GoListUnordered size={18} color={"grey"}/> },
      { label: "OL", style: "ordered-list-item" , icon: <GoListOrdered size={18} color={"grey"}/>},
      //{ label: "Blockquote", style: "blockquote" },
      //{ label: "Code Block", style: "code-block" }
    ];
  
    const BlockStyleControls = (props) => {
      return (
        <div style={{display:"flex"}}>
          {BLOCK_TYPES.map?.((type) => (
            <StyleButton
              key={type.label}
              icon={type?.icon}
    
              //label={type.label}
              onToggle={props.onToggle}
              style={type.style}
            />
          ))}
        </div>
      );
    };
  
    const INLINE_STYLES = [
      { label: "Bold", style: "BOLD", icon: <FaBold size={18} color={"grey"}/>},
      { label: "Italic", style: "ITALIC", icon: <FaItalic size={18} color={"grey"}/> },
      { label: "Underline", style: "UNDERLINE", icon: <FaUnderline size={18} color={"grey"}/> },

      //{ label: "Monospace", style: "CODE" }
    ];
    const InlineStyleControls = (props) => {
      return (
        <div style={{display:"flex"}}>
          {INLINE_STYLES.map?.((type) => (
            <StyleButton
              key={type.label}
              //label={type.label}
              icon={type.icon}
              onToggle={props.onToggle}
              style={type.style}
            />
          ))}
        </div>
      );
    };
  
    const onInlineClick = (e) => {
      let nextState = RichUtils.toggleInlineStyle(editorState, e);
      setEditorState(nextState);
      const newDoc = convertToRaw(nextState.getCurrentContent())
      editorDoc({...newDoc, _key: newDoc?.key})
    };
  
    const onBlockClick = (e) => {
      let nextState = RichUtils.toggleBlockType(editorState, e);
      setEditorState(nextState);
      const newDoc = convertToRaw(nextState.getCurrentContent())
      editorDoc({...newDoc, _key: newDoc?.key})
    };
    const border = readOnly ? {border:"none"} : {cursor:"text", borderRadius:"10px", borderColor: "#ccc", fontSize:"16px"}
    const maxWidth = fullWidth ? {} : {maxWidth: customWidth}

    const onChange = (editorState) => {
      const newDoc = convertToRaw(editorState?.getCurrentContent())
      setEditorState(editorState)
      //console.log("ON EDITOR CHANGE:", newDoc)
      editorDoc({...newDoc, _key: newDoc?.key})
    }
    return (
    <>
      <VisDiv rules={[testing, !readOnly]}><button onClick={testFunction}>Test</button></VisDiv>
      <VisDiv rules={[!readOnly, saveLoad]}><button onClick={saveContent}>Save Content</button></VisDiv>
      <VisDiv rules={[!readOnly, saveLoad]} ><button onClick={loadContent}>Load Content</button></VisDiv>
        <div onClick={focusEditor} >
          <VisDiv rules={[!readOnly]} style={{...border, color:"blue", display:"flex", ...maxWidth}} className="rich-editor">
            <BlockStyleControls onToggle={onBlockClick} />
            <InlineStyleControls onToggle={onInlineClick} />
          </VisDiv>
          <div style={{...border, ...maxWidth}} className="rich-editor">
            <Editor
              ref={editor}
              editorState={editorState}
              onChange={onChange}
              readOnly={readOnly}
              onBlur={onBlur}
            />
          </div>
  { /*         <Editor
              editorState={editorState}
              readOnly={true}
            /> */}

        </div>
      </>
    );
  }

export default RichTextEditor
